import { render, staticRenderFns } from "./CategoryConfigurator.vue?vue&type=template&id=22e61ca4&scoped=true&"
import script from "./CategoryConfigurator.vue?vue&type=script&lang=js&"
export * from "./CategoryConfigurator.vue?vue&type=script&lang=js&"
import style0 from "./CategoryConfigurator.vue?vue&type=style&index=0&id=22e61ca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e61ca4",
  null
  
)

export default component.exports